/**
 * The two Studio FTUX onboarding tasks shown in the sidebar "Getting started"
 * card. Order here is the order they render in.
 */
export const STUDIO_CHECKLIST_TASK_IDS = [
  'publishApp',
  'explorePortal',
] as const;

export type StudioChecklistTaskId = (typeof STUDIO_CHECKLIST_TASK_IDS)[number];

/** The task that advances on click and, once done, hides the whole checklist. */
export const EXPLORE_PORTAL_TASK_ID =
  'explorePortal' satisfies StudioChecklistTaskId;

/**
 * Task status, matching the values the backend reports. `InProgress` renders
 * the half-filled mark; `Done` is the terminal/complete state.
 */
export enum StudioChecklistTaskStatus {
  Todo = 'todo',
  InProgress = 'in-progress',
  Done = 'done',
}

export interface StudioChecklistTask {
  id: StudioChecklistTaskId;
  label: string;
  status: StudioChecklistTaskStatus;
}

export const GUIDED_TOUR_PARAM = 'guided-tour';
export const GUIDED_TOUR_FIRST_CLIENT = 'firstClient';
